import { Tooltip } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import utilsMessages from 'utils/messages';
import useResize from '../../hooks/useResize';
import Money from 'components/Money/Money';
import NoteIcon from '../ServiceFeeNote/NoteIcon';

interface VatTooltipProps {
  productVat: number;
  serviceFeeVat?: number;
  voucherVat?: number;
}

const NoteIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #4b5563;
`;

const VatItem = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #fff;
  white-space: nowrap;
`;
const VatValue = styled.span`
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: #fff;
  white-space: nowrap;
`;

const VatTooltip = (props: VatTooltipProps) => {
  const { productVat, serviceFeeVat, voucherVat } = props;

  const { isDesktop } = useResize();

  return (
    <Tooltip
      trigger={[isDesktop ? 'hover' : 'click']}
      placement="top"
      title={
        <div
          style={{
            width: 'fit-content',
          }}
        >
          <VatItem>
            <FormattedMessage {...utilsMessages.vatOnSubtotal} />:{' '}
            <VatValue>
              <Money>{productVat}</Money>
            </VatValue>
          </VatItem>
          {!!serviceFeeVat && (
            <VatItem>
              <FormattedMessage {...utilsMessages.vatOnServiceFee} />:{' '}
              <VatValue>
                <Money>{serviceFeeVat}</Money>
              </VatValue>
            </VatItem>
          )}
          {!!voucherVat && (
            <VatItem>
              <FormattedMessage {...utilsMessages.vatOnDiscountVoucher} />:{' '}
              <VatValue>
                -<Money>{voucherVat}</Money>
              </VatValue>
            </VatItem>
          )}
        </div>
      }
    >
      <NoteIconWrapper>
        <NoteIcon />
      </NoteIconWrapper>
    </Tooltip>
  );
};

export default VatTooltip;
